module.exports = __webpack_public_path__ + "img/login-image.617c3a43.png";